
import React from "react";
import { Checkbox } from "@/components/ui/checkbox";
import { Skeleton } from "@/components/ui/skeleton";
import { useAmenities } from "./hooks/useAmenities";
import { AMENITIES } from "./VehicleConstants"; // Fallback amenities

// Amenities Section
interface AmenitiesSectionProps {
  selectedAmenities: string[];
  toggleAmenity: (amenityId: string) => void;
}

export const AmenitiesSection = ({ selectedAmenities, toggleAmenity }: AmenitiesSectionProps) => {
  const { amenities, isLoading, error } = useAmenities();
  
  // Use API amenities if available, otherwise fall back to constants
  const displayAmenities = amenities.length > 0 
    ? amenities.map(a => ({ id: a.id.toString(), label: a.name }))
    : AMENITIES;
  
  return (
    <div className="space-y-3">
      <label className="block text-sm font-medium text-black">
        Amenities
      </label>
      {isLoading ? (
        <div className="grid grid-cols-2 gap-2">
          {[1, 2, 3, 4].map(i => (
            <div key={i} className="flex items-center space-x-2">
              <Skeleton className="h-4 w-4" />
              <Skeleton className="h-4 w-24" />
            </div>
          ))}
        </div>
      ) : (
        <div className="grid grid-cols-2 gap-2">
          {displayAmenities.map(amenity => (
            <div key={amenity.id} className="flex items-center space-x-2">
              <Checkbox 
                id={`amenity-${amenity.id}`}
                checked={selectedAmenities.includes(amenity.id)}
                onCheckedChange={() => toggleAmenity(amenity.id)}
              />
              <label 
                htmlFor={`amenity-${amenity.id}`}
                className="text-sm leading-none text-black"
              >
                {amenity.label}
              </label>
            </div>
          ))}
        </div>
      )}
      {error && (
        <p className="text-xs text-red-500">
          {error}
        </p>
      )}
    </div>
  );
};

export default AmenitiesSection;
